/**
 * @generated SignedSource<<b82f3080accb825186813e6e446106bc>>
 * @relayHash 9546aa62a01d6a933cab5b3e7dd73dd7
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9546aa62a01d6a933cab5b3e7dd73dd7

import { ConcreteRequest } from 'relay-runtime';
export type Ch_forceDeleteProgressNoteInput = {
  id: string;
};
export type chForceDeleteProgressNoteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_forceDeleteProgressNoteInput;
};
export type chForceDeleteProgressNoteMutation$data = {
  readonly forceDeleteProgressNote: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: {
      readonly id: string;
    } | null;
  };
};
export type chForceDeleteProgressNoteMutation = {
  response: chForceDeleteProgressNoteMutation$data;
  variables: chForceDeleteProgressNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chForceDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "forceDeleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_forceDeleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "ch_forceDeleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chForceDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "forceDeleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_forceDeleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "ch_forceDeleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "ch_ProgressNote",
            "kind": "LinkedField",
            "name": "ch_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9546aa62a01d6a933cab5b3e7dd73dd7",
    "metadata": {},
    "name": "chForceDeleteProgressNoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "721bb391a4d4ede4169aca60ff266a8f";

export default node;
